import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { Field, reduxForm } from 'redux-form';

registerLocale('es', es)


const TestSend = () => {
    
    const [file, setFile] = React.useState(null);

    function sendEmail() {

        var dataFile = new FormData();
            //console.log(file);

            //Archivo
            //dataFile.append("email", "stebanlondo75@gmail.com");
            //dataFile.append("content", file);
            //dataFile.append("file_name", file.name);
            //dataFile.append("content_type", file.type);
            

        fetch( process.env.REACT_APP_PUBLIC_URL + "factibilidad/send_email_contract", {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            console.log(response);
        }).catch(error => console.error(error));
        
    }

    return (<Container>
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <h1>Test</h1>
                    <br />
                    <div className="container pt-2 text-center">
                    <input id="testfile" name="testfile" type="file" onChange={(e) => { setFile(e.target.files[0]) }} />
                        <br /><br />
                        <Button className="text-white btn-primary" onClick={sendEmail} >Test Email</Button>
                    </div>
                </CardBody>
            </Card>
        </Col>
    </Container >);
}

export default reduxForm({
    form: 'test_send_form', // a unique identifier for this form
})(TestSend);